import { axiosInstance } from 'boot/axios.js'

export async function query(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: '/surveys',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('items', response.data.items)
    ctx.commit('pagination', response.data.pagination)
    return response
  } catch (e) {
    return e
  }
}

export async function getMspns(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: '/mspn',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('itemsMspns', response.data.items)
    ctx.commit('pagination', response.data.pagination)
    return response
  } catch (e) {
    return e
  }
}

export async function save(ctx, data) {
  try {
    const response = await axiosInstance({
      url: '/surveys',
      data: data,
      method: 'POST'
    })
    return response
  } catch (e) {
    return e
  }
}

export async function get(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: `/surveys/${queryParams.id}`,
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('item', response.data)
    return response
  } catch (e) {
    return e
  }
}

export async function download(ctx, data) {
  try {
    const response = await axiosInstance({
      url: '/surveys/template',
      method: 'GET'
    })
    return response
  } catch (e) {
    return e
  }
}

